export default "__VITE_ASSET__BvigkfdG__"